module.exports = __webpack_public_path__ + "img/sf.d6eddf89.png";